import { Segment } from "../models/email-template/segment.interface";

// Create a Map with all the segments
export const segmentsForSelect: Segment[] = [
  {displayName: "None", content: ""},
  {displayName: "Family", content: "family"},
  {displayName: "Couples", content: "couples"},
];
